import { render, staticRenderFns } from "./ColumnsEditor.vue?vue&type=template&id=4c40ca0c"
import script from "./ColumnsEditor.vue?vue&type=script&lang=js"
export * from "./ColumnsEditor.vue?vue&type=script&lang=js"
import style0 from "./ColumnsEditor.vue?vue&type=style&index=0&id=4c40ca0c&prod&lang=stylus&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports